// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon__388Ky","count":"count__2dlmn","files":"files__3TfH7"};